import React, { useState } from "react";
import DatePicker from "react-datepicker";
import Iframe from 'react-iframe'
import LoadingOverlay from 'react-loading-overlay';

import "react-datepicker/dist/react-datepicker.css";
import { withRouter } from 'react-router-dom'
import "./Welcome.css";
import "./Home.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

class Home extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
        setTimeout(
            () => this.setState({ isActive: false }),
            5500
        );
    }
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            isActive: true
        };


    }
    dateHandler = (sdate) => {
        this.setState({ startDate: sdate });
        console.log('date setting ...' + JSON.stringify(this.state));

    }
    render() {
        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner
                text='Loading ...'
            >
                <div id="LoginForm">
                    <Navbar />
                    
                    <Iframe 
                        url={this.props.location.state.url}
                        width="100%"
                        height="600px"
                        id="myId"
                        className="myClassname"
                        display="initial"
                        position="relative" 
                        styles={{padding: "25px"}}
                    />

                    <Footer />
                </div>
            </LoadingOverlay>
        )
    }
}
export default withRouter(Home);
